import {FC, useEffect, RefObject} from "react";
import {SpeedLineIcon} from "../icons/SpeedLineIcon";
import {SpeedComponentWrapper} from "../styles";
import {useDispatch, useSelector} from "react-redux";
import {selectorAudioSpeed, setAudioSpeed} from "../reducers/AudioSlice";

enum SpeedType {
    Slow = 0.5,
    Normal = 1,
    Fast = 1.5,
    Very_Fast = 2
}

const SPEED_LIST = [SpeedType.Normal, SpeedType.Fast, SpeedType.Very_Fast, SpeedType.Slow];

export const SpeedComponent: FC<{audioRef: RefObject<HTMLAudioElement>, hidden?: boolean}> = ({audioRef, hidden}) => {

    const dispatch = useDispatch()
    const currentSpeedIndex = useSelector(selectorAudioSpeed)

    const handleClick = () => {
        const newIndex = currentSpeedIndex + 1 === SPEED_LIST.length ? 0 : currentSpeedIndex + 1;
        dispatch(setAudioSpeed(newIndex))
    }

    useEffect(() => {
        if (!audioRef?.current) return;
        audioRef.current.playbackRate = SPEED_LIST[currentSpeedIndex]
    }, [currentSpeedIndex, audioRef])

    return (
        <SpeedComponentWrapper onClick={handleClick} hidden={hidden}>
            <SpeedLineIcon/>
            {SPEED_LIST[currentSpeedIndex]}x
            <SpeedLineIcon/>
        </SpeedComponentWrapper>
    )
}import {FC, useEffect, RefObject} from "react";
import {SpeedLineIcon} from "../icons/SpeedLineIcon";
import {SpeedComponentWrapper} from "../styles";
import {useDispatch, useSelector} from "react-redux";
import {selectorAudioSpeed, setAudioSpeed} from "../reducers/AudioSlice";

enum SpeedType {
    Slow = 0.5,
    Normal = 1,
    Fast = 1.5,
    Very_Fast = 2
}

const SPEED_LIST = [SpeedType.Normal, SpeedType.Fast, SpeedType.Very_Fast, SpeedType.Slow];

export const SpeedComponent: FC<{audioRef: RefObject<HTMLAudioElement>, hidden?: boolean}> = ({audioRef, hidden}) => {

    const dispatch = useDispatch()
    const currentSpeedIndex = useSelector(selectorAudioSpeed)

    const handleClick = () => {
        const newIndex = currentSpeedIndex + 1 === SPEED_LIST.length ? 0 : currentSpeedIndex + 1;
        dispatch(setAudioSpeed(newIndex))
    }

    useEffect(() => {
        if (!audioRef?.current) return;
        audioRef.current.playbackRate = SPEED_LIST[currentSpeedIndex]
    }, [currentSpeedIndex, audioRef])

    return (
        <SpeedComponentWrapper onClick={handleClick} hidden={hidden}>
            <SpeedLineIcon/>
            {SPEED_LIST[currentSpeedIndex]}x
            <SpeedLineIcon/>
        </SpeedComponentWrapper>
    )
}